import axios from '@/api/requests/axios'

export default {
  getAll: params => axios.get('/api/admin/v1/vacancies', { params }),
  getById: id => axios.get(`/api/admin/v1/vacancies/${id}`),
  create: promotion => axios.post('/api/admin/v1/vacancies', promotion),
  update: promotion => axios.put('/api/admin/v1/vacancies', promotion),
  delete: id => axios.delete(`/api/admin/v1/vacancies/${id}`),
}
